import { useNotificationRefresh } from 'utils/hooks/useNotificationRefresh';
import { useGetUserAgendaNotificationsQuery } from 'store/services/core/userNotifications';

type useNotificationsCountProps = {
  enabledUserDashboard?: boolean;
};

const useNotificationsCount = ({ enabledUserDashboard }: useNotificationsCountProps) => {
  const { data: infoNotifications = [], refetch: refetchInfoNotifications } = useGetUserAgendaNotificationsQuery(
    { actionRequired: false },
    { skip: !enabledUserDashboard }
  );
  const { data: actionNotifications = [], refetch: refetchActionNotifications } = useGetUserAgendaNotificationsQuery(
    { actionRequired: true },
    { skip: !enabledUserDashboard }
  );

  useNotificationRefresh(() => {
    refetchInfoNotifications();
    refetchActionNotifications();
  });

  return { infoNotifications, actionNotifications };
};

export { useNotificationsCount };
